import { UserInfoEntity } from "@/domain/entity/user/user-info-entity";
import { AuthRepository } from "@/domain/repository/auth-repository";
import { UserRepository } from "@/domain/repository/user-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class RefreshWebSessionUsecase {
  constructor(
    private readonly authRepo: AuthRepository,
    private readonly userRepo: UserRepository,
  ) {}

  async execute(): Promise<SATResult<UserInfoEntity, SATError>> {
    const tokenResult = await this.authRepo.reissueWebUserToken();
    if (tokenResult.isFailure) {
      return SATResult.failure(tokenResult.error);
    }

    const keyResult = await this.authRepo.exchangeAndSaveAESecretKeyByCookie();
    if (keyResult.isFailure) {
      return SATResult.failure(keyResult.error);
    }

    return this.userRepo.fetchWebUserInfo();
  }
}
